import { SidePanelState } from '../store/sidePanelState';

export function getSidePanelWidth(
  screenWidth: number,
  isPageFile = false,
): Record<SidePanelState, number> {
  let expanded = 302;

  if (screenWidth > 1400 && isPageFile) {
    expanded = 400;
  }

  return {
    collapsed: 0,
    expanded,
  };
}
